<!--
 * @Author: Merlin
 * @Date: 2024-01-15 11:08:13
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-27 16:06:31
 * @Description: 
    💛 slot 1 背景： #bgContent（可选）
    💛 slot 2 左侧： #panel-left
    💛 slot 3 右侧： #playing-area-right
-->
<template>
    <div class="game-coat casino-container" 
        :style="{'--top-height': topHeight}" 
    >
        <!-- ↓ 底层背景区 -->
        <section class='background-outer'
            style_stop_using="oBgSetting"
        >
            <div class="bg-img-container">
                <slot name="bgImg"></slot>
            </div>
            <!-- ↓ 背景元素（可选的 slot 只有 crash 游戏用到了）-->
            <div class="bg-content" v-if="$slots.bgContent">
                <slot name="bgContent"></slot>
            </div>
            <!-- ↓ 周边的黑色渐变，将来需要时把 v-if 改为某变量 -->
            <template v-if="1">
                <div class="gradient-bottom"></div>
                <div class="gradient-left"></div>
                <div class="gradient-right"></div>
            </template>
        </section>
        <!-- ↑ 底层背景区 -->
        <!-- ↓ 上层的，顶部的游戏区 -->
        <section class="wide-controler game-area casino-main" 
            :ref="el => oCoatDom = el"
        >
            <GameSettingsDiceTabsWrapper
                class="flex !justify-end !mb-3 relative z-[2] border-none"
            >
                <ClientOnly>
                    <GameSettingsButtonLiveChat v-if="userStore.isLoggedIn" v-model="oVisible.statistics" />
                </ClientOnly>
                <GameSettingsButtonAnimate
                    v-show="isCrash"
                    v-model="oGameSetting.animation" 
                />
                <!-- 注意，↑↓ 上下两者互斥，不要使用 v-if 防止 hydration 报错 --> 
                <GameSettingsButtonFast
                    v-show="!isCrash && oJoinStateStore.gameOfRoute != 'blackjackGame'"
                    v-model="oGameSetting.fast" 
                />
                <GameSettingsButtonFairness
                    v-model="oVisible.fairness"
                />
                <GameSettingsButtonRule
                    v-model="oVisible.rule"
                    :name="gameName"
                />
                <GameSettingsButtonVocie
                    v-model="oSettingsStore.inhouseGames.sound.on"
                    v-model:voice-model-value="oSettingsStore.inhouseGames.sound.music"
                    :saveAfterChange="true"
                ></GameSettingsButtonVocie>
                <!-- ↓ 新需求要弃用这个控件 -->
                <!-- <GameSettingsButtonVocie02/> -->
            </GameSettingsDiceTabsWrapper>
            <!--
                ↑ 后补的游戏上方的一排操控按钮 💥
                ↓ 游戏操控区 💥
            -->
            <div class="game-layout">
                <section class="panel-left">
                    <slot name="panel-left">LeftPart</slot>
                </section>
                <!--
                    左右分界
                -->
                <section class="playing-area-right">
                    <slot name="playing-area-right">RightPart</slot>
                </section>
            </div>
        </section>

        <!-- ↓ 最下方的历史记录 -->
        <section class="wide-controler">
            <CasinoHistory />
        </section>
    </div>
    <!-- ↓弹出窗口 -->
    <ClientOnly v-if="toShowIntroduction">
        <ModalGameIntroduction />
    </ClientOnly>
</template>

<script>
export default defineComponent({name: 'GameCoat'});
</script>

<script setup>
import {toCloseLoading} from './ts/gameCoat';
import oScssVar from '~/common/style/game.module.scss';
import useGlobalStore from '@/stores/global';
import {useJoinStateStore} from '@/stores/cansino/joinState';
import useSettingsStore from '@/stores/settings/index';
import { useUserStore } from '~/stores/user';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'

// ========================================================
const userStore = useUserStore();
const oSettingsStore = useSettingsStore();
const oJoinStateStore = useJoinStateStore();
const globalStore = useGlobalStore();
// ========================================================

const props = defineProps({
    topHeight: { // 上方游戏区的高度
        type: String,
        default: '603px', 
    },
    // bgImage: { // 上方背景图，停用于 2025.02.04 19:06:03 星期二 
    //     type: String,
    //     default: '',
    // },
    oOtherParams: {
        type: Object, // 个别游戏特定参数，
        default: ()=>({}),
    },
});

// ↓ 表示是否需要弹出
const toShowIntroduction = ref(false);
const oCoatDom = ref(null);
const emit = defineEmits(['domSender']);
const abortController = ref(null);
const rect = ref(null);
const currScale = ref(null); // 进入页面时的缩放比例

const oVisible = reactive({
    statistics: false,
    fairness: false,
    rule: false,
    jackpotVisible: false,
});

// ↓ 游戏设定：fast, animate 
const oGameSetting = computed(() => {
    const { gameOfRoute } = oJoinStateStore;
    if (gameOfRoute == 'kenoGame') {
        return oSettingsStore.inhouseGames.keno;
    } else if (gameOfRoute == 'rouletteGame') {
        return oSettingsStore.inhouseGames.roulette;
    } else if (gameOfRoute == 'minesGame') {
        return oSettingsStore.inhouseGames.mines;
    } else if (gameOfRoute == 'corgipharaohGame') {
        return oSettingsStore.inhouseGames.pharaoh;
    }
    // ↓ 此游戏没有 fast 与否的相关设定 
    else if (gameOfRoute == 'crashGame') {
        return oSettingsStore.inhouseGames.crash;
    }
    // ↓ mini 版中不再开放这个游戏的 fast, 与 animate 的状态切换功能 
    // else if (gameOfRoute == 'blackjackGame') {
    //     return oSettingsStore.inhouseGames.blackjack;
    // }
    return {};
});

const gameName = computed(()=>{
    let sGame = oJoinStateStore.gameOfRoute;
    sGame = sGame.replace('Game', '');
    return sGame;
});

const isCrash = computed(()=>{
    return (
        globalStore.client
        && ['crashGame'].includes(oJoinStateStore.gameOfRoute)
    );
});

// ↓ 停用了，改为插入 <slot> 为背景了（提升加载优先级） 
// const oBgSetting = computed(()=>{
//     const oStyle = {
//         'background-image': (()=>{
//             if (props.bgImage.includes('/')) {
//                 return `url(${props.bgImage || ''})`
//             }
//             return props.bgImage; // 
//         })(),
//     };
//     if (oJoinStateStore.gameOfRoute == 'blackjackGame'){
//         Object.assign(oStyle, props.oOtherParams);
//     }
//     return oStyle;
// });


// ↓监听窗口打开（以便做记录，防止再次打开） 
watch(()=>oJoinStateStore.gameOfRoute, (sGame, sOldGame)=>{
    // ↓ mark 为 true 则表示曾经有弹出，不应再弹出 
    const mark = oSettingsStore.inhouseGames.onBoarding[sGame];
    const aGameList = ['corgipharaohGame', 'rouletteGame'];
    let bValue = aGameList.includes(sGame) && !mark;
    // console.log(`👽 弹出? ${sOldGame} => ${sGame} =>`, bValue); 
    if (!bValue) return;
    // ↓打开窗口
    toShowIntroduction.value = true; 
    // ↓添加标记，防止二次弹出 
    oSettingsStore.inhouseGames.onBoarding[sGame] = true;
}, {
    immediate: true,
    deep: true,
});


const oScreen = {
    iWithE: Number.parseInt(oScssVar.myWidthE),
};
/**
 * 监听视图高度变化，使页面等比例缩放
 */
const handleResize = () => {
    const casinoContainer = document.querySelector('.casino-container');
    if (!casinoContainer) return; 
    // 获取视口的高度
    const viewportHeight = window.innerHeight;
    const { bottom, y } = rect.value;
    const scrollTop = window.scrollY || window.pageYOffset;
    if (bottom > viewportHeight && scrollTop < viewportHeight){ 
        let scale = viewportHeight / (bottom + y);
        if (viewportHeight < 240){
            scale = viewportHeight / (bottom * 1.5);
        }
        if (viewportHeight < 180){
            scale = viewportHeight / (bottom * 2);
        }
        casinoContainer.style.transform = `scale(${scale})`;
        casinoContainer.style.transformOrigin = 'top center';
    } else {
        casinoContainer.style.transform = `scale(1)`;
    }
    // 存储一下当前页面的缩放比例
    currScale.value = Number(casinoContainer.style.transform.slice(6, casinoContainer.style.transform.length - 1));
}
/**
 * 监听页面滚动
 * 当页面滚动距离>视图高度的1/3时，则将页面放大为1:1，否则执行resize事件
 */
const handleScroll = () => {
    const casinoContainer = document.querySelector('.casino-container');
    if (!casinoContainer) return;
    // 获取视口的高度
    const viewportHeight = window.innerHeight;
    // 页面滚动距离
    const scrollTop = window.scrollY || window.pageYOffset;
    const singScale = (1 - currScale.value) / 4;
    // 使页面缩放过渡更平滑，添加多段缩放
    if (scrollTop >= (viewportHeight / 4) && scrollTop < (viewportHeight / 3)){
        casinoContainer.style.transform = `scale(${currScale.value + singScale})`;
    } else if (scrollTop >= (viewportHeight / 3) && scrollTop < (viewportHeight / 2)){
        casinoContainer.style.transform = `scale(${currScale.value + singScale * 2})`;
    } else if (scrollTop >= (viewportHeight / 2) && scrollTop < (viewportHeight)){
        casinoContainer.style.transform = `scale(${currScale.value + singScale * 3})`;
    } else if (scrollTop >= (viewportHeight)){
        casinoContainer.style.transform = `scale(1)`;
    }  else {
        handleResize()
    }
}
onBeforeMount(()=>{
    toCloseLoading();
});
onMounted(()=>{
    emit('domSender', oCoatDom.value);
    setTimeout(() => {
        const casinoMain = document.querySelector('.casino-container .casino-main');
        if (!casinoMain) return; 
        rect.value = casinoMain.getBoundingClientRect();
        handleResize();
        abortController.value = new AbortController();
        window.addEventListener('resize', handleResize, {
            signal: abortController.value.signal,
        });
        window.addEventListener('scroll', handleScroll, {
            signal: abortController.value.signal,
        })
    })
    onUnmounted(() => {
        abortController.value?.abort();
    })
});

</script>


<style lang="scss" scoped src="./style/game-coat.scss"></style>

<!-- ↓ 这个 <style> 内的样式有意向子组件辐射 -->
<style lang="scss" scoped>
@import '@/common/style/game.module.scss';

.game-coat :deep(){
    .wide-controler{
        --sides-wide: 24px;
        width: 100%;
        max-width: 1088px;
        margin: 0 auto;
        padding-left: var(--sides-wide);
        padding-right: var(--sides-wide);
        // border-width: 0 var(--sides-wide) 0;
        // border-style: solid;
        // border-color: transparent;
        position: relative;
        @media all and (max-width: $with-C){
            &{
                --sides-wide: 16px;
            }
        }
    }
}
.casino-container {
    transition: transform 0.3s linear;
}
</style>





